import React, { memo } from 'react'
import styled from '@emotion/styled'
import { useTheme } from 'emotion-theming'
import { string, number } from 'prop-types'

const Svg = styled.svg`
	&:hover {
		circle {
			fill: ${({ hoverBackgroundColor }) => (hoverBackgroundColor ? hoverBackgroundColor : 'transparent')};
		}
		path {
			fill: ${({ hoverColor }) => hoverColor};
			stroke: ${({ hoverColor }) => hoverColor};
		}
	}
`

export const Facebook = memo(({ height = 30, variant = 'primary', width = 30 }) => {
	const {
		colors,
		socialProfileSvgs: { inverse, neutral, primary },
	} = useTheme()
	let backgroundColor = 'transparent'
	let fillColor = colors.secondary
	let hoverBackgroundColor = 'transparent'
	let hoverColor = colors.tertiary

	switch (variant) {
		case 'neutral':
			backgroundColor = neutral.backgroundColor
			fillColor = neutral.fillColor
			hoverBackgroundColor = neutral.hoverBackgroundColor
			hoverColor = neutral.hoverFillColor
			break
		case 'inverse':
			fillColor = inverse.fillColor
			hoverColor = inverse.hoverFillColor
			break
		case 'primary':
		default:
			fillColor = primary.fillColor
			hoverColor = primary.hoverFillColor
			break
	}
	return (
		<Svg
			height={height}
			width={width}
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			x="0px"
			y="0px"
			viewBox="0 0 26.1 26.1"
			style={{ enableBackground: 'new 0 0 26.1 26.1' }}
			xmlSpace="preserve"
			hoverColor={hoverColor}
			hoverBackgroundColor={hoverBackgroundColor}
		>
			<circle id="top" cx={13.1} cy={13.1} r={13.1} fill={backgroundColor} />
			<path
				fill={fillColor}
				stroke={fillColor}
				strokeWidth={0.5}
				strokeMiterlimit={10}
				d="M13,26.1c-7.2,0-13-5.8-13-13s5.8-13,13-13s13,5.8,13,13C26,20.2,20.2,26,13,26.1z M13,1C6.4,1,1,6.4,1,13
                s5.4,12,12,12s12-5.4,12-12S19.6,1,13,1z"
			/>
			<path
				fill={fillColor}
				stroke={fillColor}
				strokeWidth={0.5}
				strokeMiterlimit={10}
				d="M14.6,20.2h-3.8v-6.7H9.4v-3.3h1.4V9.4c0-2.3,1.2-3.5,3.5-3.5h2.3v3.3H15c-0.3,0-0.4,0-0.4,0.1s0,0.1,0,0.4v0.6
                h2.1l-0.4,3.3h-1.8L14.6,20.2L14.6,20.2z M11.8,19.2h1.7v-6.7h1.9l0.1-1.2h-2V9.6c0-0.7,0.2-1.4,1.4-1.4h0.6V6.9h-1.3
                c-1.8,0-2.5,0.7-2.5,2.5v1.9h-1.4v1.2h1.4v6.7C11.7,19.2,11.8,19.2,11.8,19.2z"
			/>
		</Svg>
	)
})
Facebook.propTypes = {
	color: string,
	height: number,
	width: number,
}
